/**
 * Admin touch polish — makes the admin feel like a native app on touch devices (iPad):
 * kills pinch-zoom, double-tap zoom, and the long-press callout/selection menu. iOS Safari ignores
 * `user-scalable=no` in the viewport meta, so zoom MUST be blocked here in JS. One-finger
 * scrolling/swiping is never touched (only 2+ finger gestures are blocked), and real form fields
 * keep their caret / paste menu so typing is unaffected.
 */
(function () {
  'use strict';

  // Form fields must keep the native selection + paste/callout menu.
  var isFormField = function (t) {
    return !!(t && t.closest && t.closest('input, textarea, select, [contenteditable], [contenteditable] *, [data-selectable], [data-selectable] *'));
  };

  // iOS pinch-zoom fires the non-standard gesture* events — swallow them.
  var onGesture = function (e) { e.preventDefault(); };

  // Multi-touch (pinch) zoom via touch events — only block 2+ fingers, so 1-finger scroll/swipe is
  // completely untouched (this covers browsers that don't fire gesture* events).
  var onTouchMove = function (e) { if (e.touches && e.touches.length > 1) e.preventDefault(); };

  // Double-tap-to-zoom — swallow the quick second tap (touch-action:manipulation catches most; this
  // covers the stragglers). Doesn't affect fast scrolling or taps in form fields.
  var lastTouchEnd = 0;
  var onTouchEnd = function (e) {
    var now = e.timeStamp || Date.now();
    if (now - lastTouchEnd < 320 && !isFormField(e.target)) e.preventDefault();
    lastTouchEnd = now;
  };

  // Long-press context menu / callout — keep it for form fields (paste); kill it everywhere else so
  // there's no save/copy/share callout on images or accidental text-selection popovers.
  var onContextMenu = function (e) {
    if (!isFormField(e.target)) e.preventDefault();
  };

  document.addEventListener('gesturestart', onGesture, { passive: false });
  document.addEventListener('gesturechange', onGesture, { passive: false });
  document.addEventListener('gestureend', onGesture, { passive: false });
  document.addEventListener('touchmove', onTouchMove, { passive: false });
  document.addEventListener('touchend', onTouchEnd, { passive: false });
  document.addEventListener('contextmenu', onContextMenu);

  // ── No pull-to-refresh in the admin ──────────────────────────────────────────────────────────
  // The live release pages deliberately re-enable native pull-to-refresh; the admin must NOT reload
  // from a downward swipe. overscroll-behavior:none (in style.css) covers modern browsers — this is
  // the guaranteed backstop: on touchstart find the scrollable ancestor under the finger; on
  // touchmove, if that scroller is already at the top and the finger is pulling DOWN, cancel it (only
  // the top-overscroll triggers refresh — real scrolling always has content to move to, so this never
  // fights a legitimate scroll). Touches inside the cross-origin preview iframe don't reach here — the
  // preview's own refresh is disabled on the gooey side (html.admin-preview-mode).
  var ptrY0 = 0, ptrScroller = null;
  function ptrFindScroller(el) {
    while (el && el.nodeType === 1) {
      if (el.scrollHeight > el.clientHeight) {
        var oy = getComputedStyle(el).overflowY;
        if (oy === 'auto' || oy === 'scroll' || oy === 'overlay') return el;
      }
      el = el.parentElement;
    }
    return null;
  }
  document.addEventListener('touchstart', function (e) {
    if (!e.touches || e.touches.length !== 1) { ptrScroller = null; return; }
    ptrY0 = e.touches[0].clientY;
    ptrScroller = ptrFindScroller(e.target);
  }, { passive: true });
  document.addEventListener('touchmove', function (e) {
    if (!e.touches || e.touches.length !== 1) return;
    if (e.touches[0].clientY - ptrY0 <= 0) return;          // pulling up = normal scroll, never refresh
    if ((!ptrScroller || ptrScroller.scrollTop <= 0) && e.cancelable) e.preventDefault();
  }, { passive: false });
})();
